<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6 form-group">
      <label>{{ 'organizations.name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['name']"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'organizations.address' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['address']"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'organizations.description' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['description']"></app-input-with-error>
    </div>
  </div>
  <app-error [error]="error"></app-error>
</form>
